import API from '@/API/API'

const ListingsStore = {
  api: API,
  state: {
    currentUserId: '',
    listings: [],
    cancelListingId:null
  },
  reset:function() {
    this.state = {
      currentUserId: '',
      listings: []
    }
  },
  getListings: function(success,error,maintenance){
    let self = this;
    this.api
    .getListings(this.state.currentUserId)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            self.state.listings = data.listings.filter(it => {
              return !it.deleted
            });

            self.state.listings = self.state.listings.map(it => {
              let name = "";
              (it.fields || []).forEach(field => {
                if(field.fieldName == "Name" || field.fieldName == "Competition Name" || field.fieldName == "Company" || field.fieldName == "Company Name" || field.fieldName == "Studio Name" || field.fieldName == "Name Of College") {
                  name = field.value || '';
                }
              });
              it.name = name;
              return it
            });

            success(self.state.listings)
        }
      }else{
          error("Failed to get listings");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  cancelFreeListing: function(success,error,maintenance){
    let self = this;
    this.api
    .cancelFreeListing(this.state.cancelListingId)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            success()
        }
      }else{
          error("Failed to get listings");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  }
}

export default ListingsStore



// WEBPACK FOOTER //
// ./src/components/account/ListingsStore.js